const Stop = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M 0 0 V -1 H 24 V 24 H 0 Z" fill="#678299" id={'stopRect'} />
    </svg>
  );
};

export default Stop;
